import useSessionProvider from 'providers/SessionProvider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const Expired = () => {
    const { i18n } = useTranslation();
    const { survey } = useSessionProvider();
    useEffect(() => {
        document.body.classList.remove('body--survey');
    }, []);
    return (
        <div className="container container-md">
            <div className="thank-you">
                <div className="thankyou__image">
                    {survey?.expirePage?.banner && <img src={survey?.expirePage?.banner} alt="Expire Banner" />}
                </div>
                <div className="thankyou__content">
                    <div className="thankyou--icon ">
                        <i className="fa-light fa-triangle-exclamation"></i>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: survey?.expirePage?.text[i18n.language] }}></div>
                </div>
            </div>
            <div className="thankyou--footer">
                <div className="thankyou--footer">
                    {survey?.expirePage?.social && (
                        <ul className="social-list">
                            {survey?.expirePage?.social &&
                                survey.expirePage?.twitter &&
                                survey?.expirePage?.twitterUrl && (
                                    <li>
                                        <a
                                            className="twitter"
                                            href={survey?.expirePage?.twitterUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.expirePage?.social &&
                                survey.expirePage?.youtube &&
                                survey?.expirePage?.youtubeUrl && (
                                    <li>
                                        <a
                                            className="youtube"
                                            href={survey?.expirePage?.youtubeUrl}
                                            target="_blank"
                                            rel="noreferrer">
                                            <i className="fa-brands fa-youtube"></i>
                                        </a>
                                    </li>
                                )}
                            {survey?.expirePage?.social &&
                                survey.expirePage?.linkedIn &&
                                survey?.expirePage?.linkedInUrl && (
                                    <li>
                                        <a
                                            className="linkedin"
                                            href={survey?.expirePage?.linkedInUrl}
                                            rel="noreferrer"
                                            target="_blank">
                                            <i className="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                )}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Expired;
